
  function initializeDiscovery(selector) {
    if (selector.dataset.initialized === 'true') return;
    selector.dataset.initialized = 'true';

    const form = selector.closest('form');

    if (!form) return;

    const optionsContainer = selector.querySelector(
      '[data-discovery-options]'
    );

    const options = Array.from(
      selector.querySelectorAll('[data-discovery-option]')
    );

    const searchInput = selector.querySelector(
      '[data-discovery-search]'
    );

    const counter = selector.querySelector(
      '[data-discovery-counter]'
    );

    const status = selector.querySelector(
      '[data-discovery-status]'
    );

    const summary = selector.querySelector(
      '[data-discovery-summary]'
    );

    const readyBadge = selector.querySelector(
      '[data-discovery-ready]'
    );

    const noResults = selector.querySelector(
      '[data-discovery-no-results]'
    );

    const submitButton = form.querySelector(
      '[data-discovery-submit]'
    );

    const propertyInputs = Array.from(
      selector.querySelectorAll('[data-discovery-property]')
    );

    const maxSelections = 5;

    let selected = [];


    function normalise(value) {

      return String(value || '')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();

    }


    function getProductFromOption(option) {

      return {
        title: option.dataset.productTitle || '',
        handle: option.dataset.productHandle || ''
      };

    }


    function updateHiddenProperties() {

      propertyInputs.forEach(function (input, index) {

        input.value = selected[index]
          ? selected[index].title
          : '';

      });

    }


    function updateSummary() {

      if (!summary) return;

      const rows = summary.querySelectorAll(
        '[data-discovery-summary-item]'
      );

      rows.forEach(function (row, index) {

        const name = row.querySelector(
          '.alamina-discovery-summary__name'
        );

        if (selected[index]) {

          row.classList.add('has-selection');

          if (name) {
            name.textContent = selected[index].title;
          }

        } else {

          row.classList.remove('has-selection');

          if (name) {
            name.textContent = 'Choose a fragrance';
          }

        }

      });

    }


    function updateCounter() {

      const count = selected.length;

      if (!counter) return;

      const strong = counter.querySelector('strong');

      if (strong) {
        strong.textContent = count;
      }

      counter.classList.toggle(
        'is-complete',
        count === maxSelections
      );

    }


    function updateStatus() {

      const count = selected.length;

      if (!status) return;

      status.classList.remove(
        'is-ready',
        'is-warning'
      );

      if (count === maxSelections) {

        status.textContent =
          '✓ Your Discovery Set is ready.';

        status.classList.add('is-ready');

        if (readyBadge) {
          readyBadge.hidden = false;
        }

        return;
      }

      if (readyBadge) {
        readyBadge.hidden = true;
      }

      const remaining =
        maxSelections - count;

      if (count === 0) {

        status.textContent =
          'Choose five fragrances to continue.';

      } else {

        status.textContent =
          'Choose ' +
          remaining +
          ' more fragrance' +
          (remaining === 1 ? '' : 's') +
          '.';

      }

    }


    function updateSubmitButton() {

      if (!submitButton) return;

      const available =
        normalise(
          submitButton.dataset.productAvailable
        ) === 'true';

      const ready =
        selected.length === maxSelections;

      const text = submitButton.querySelector(
        '[data-addtocart-text]'
      );

      if (!available) {

        submitButton.disabled = true;

        if (text) {
          text.textContent = 'Sold Out';
        }

        return;
      }

      submitButton.disabled = !ready;

      if (!text) return;

      if (ready) {

        text.textContent =
          submitButton.dataset.readyLabel ||
          'Add Discovery Set';

      } else {

        const remaining =
          maxSelections - selected.length;

        if (selected.length === 0) {

          text.textContent =
            'Select 5 Fragrances';

        } else {

          text.textContent =
            'Select ' +
            remaining +
            ' More';

        }

      }

    }


    function updateOptionStates() {

      options.forEach(function (option) {

        const handle =
          option.dataset.productHandle;

        const chosen = selected.some(
          function (item) {
            return item.handle === handle;
          }
        );

        option.classList.toggle(
          'is-selected',
          chosen
        );

        const checkbox = option.querySelector(
          '.alamina-discovery-option__checkbox'
        );

        if (checkbox) {
          checkbox.checked = chosen;
        }

        const shouldDisable =
          selected.length >= maxSelections &&
          !chosen;

        option.classList.toggle(
          'is-disabled',
          shouldDisable
        );

        if (checkbox) {
          checkbox.disabled = shouldDisable;
        }

      });

    }


    function updateAll() {

      updateHiddenProperties();
      updateSummary();
      updateCounter();
      updateStatus();
      updateSubmitButton();
      updateOptionStates();

    }


    function toggleProduct(option) {

      const selectedProduct =
        getProductFromOption(option);

      if (
        !selectedProduct.handle ||
        !selectedProduct.title
      ) {
        return;
      }

      const existingIndex =
        selected.findIndex(function (item) {
          return item.handle === selectedProduct.handle;
        });

      if (existingIndex > -1) {

        selected.splice(
          existingIndex,
          1
        );

      } else {

        if (
          selected.length >=
          maxSelections
        ) {

          if (status) {

            status.textContent =
              'You have already selected five fragrances. Remove one to choose another.';

            status.classList.remove('is-ready');
            status.classList.add('is-warning');

          }

          return;
        }

        selected.push(
          selectedProduct
        );

      }

      updateAll();

    }


    options.forEach(function (option) {

      const checkbox = option.querySelector(
        '.alamina-discovery-option__checkbox'
      );

      if (!checkbox) return;

      checkbox.addEventListener(
        'change',
        function () {
          toggleProduct(option);
        }
      );

    });


    function filterOptions() {

      const query = normalise(
        searchInput
          ? searchInput.value
          : ''
      );

      let visibleCount = 0;

      options.forEach(function (option) {

        const title = normalise(
          option.dataset.productTitle
        );

        const matches =
          !query ||
          title.includes(query);

        option.hidden = !matches;

        if (matches) {
          visibleCount += 1;
        }

      });

      if (noResults) {
        noResults.hidden =
          visibleCount !== 0;
      }

    }


    if (searchInput) {

      searchInput.addEventListener(
        'input',
        filterOptions
      );

    }


    form.addEventListener(
      'submit',
      function (event) {

        if (
          selected.length !==
          maxSelections
        ) {

          event.preventDefault();
          event.stopImmediatePropagation();

          if (status) {

            status.textContent =
              'Please choose exactly five fragrances before adding your Discovery Set to cart.';

            status.classList.remove('is-ready');
            status.classList.add('is-warning');

          }

          selector.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });

          return false;
        }

      },
      true
    );


    if (options.length === 0) {

      if (status) {

        status.textContent =
          'No Discovery Set fragrances are currently available.';

        status.classList.add('is-warning');

      }

      if (submitButton) {
        submitButton.disabled = true;
      }

    } else {

      const sortedOptions = options
        .slice()
        .sort(function (a, b) {

          return (
            a.dataset.productTitle ||
            ''
          ).localeCompare(
            b.dataset.productTitle ||
            ''
          );

        });

      sortedOptions.forEach(function (option) {

        optionsContainer.appendChild(
          option
        );

      });

    }

    updateAll();

  }
function initializeDiscoverySets(root = document) {
  root.querySelectorAll('[data-discovery-set-selector]').forEach(initializeDiscovery);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeDiscoverySets());
} else {
  initializeDiscoverySets();
}
document.addEventListener('shopify:section:load', event => initializeDiscoverySets(event.target));
